import { PropsWithChildren } from 'react';
import classNames from 'classnames';

import { Icon } from '@canvas-logic/clp-shared-ui';

import styles from './SelectOptionAction.module.css';

interface SelectOptionActionProps {
  onClick: () => void;
  selected?: boolean;
}

export const SelectOptionAction = ({ children, selected, onClick }: PropsWithChildren<SelectOptionActionProps>) => {
  return (
    <div data-select className={classNames(styles.root, { [styles.selected]: selected })}>
      <div data-select-shadow tabIndex={0} role="button" className={styles.button} onClick={onClick}>
        {children}
        <div className={styles.arrowWrapper}>
          <Icon type="arrow" />
        </div>
      </div>
    </div>
  );
};
